import { Button, useTheme, useMediaQuery } from '@mui/material'
import { styled, width } from '@mui/system'

export const HeaderButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: '#fff',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    width: '160px',
  },
}))
